import type { ModelEditButtonLegacyProps } from "./model-edit-button-legacy.type";
import type { ButtonProps } from "antd";

import { Button } from "antd";
import { useTranslation } from "react-i18next";

import { useAuthorization } from "@/modules/authorization";
import { getModelTranslationKey, type ModelItem } from "@/modules/model";
import { useSidePanel } from "@/modules/side-panel";

/** @deprecated - Create specific button for each model instead */
const ModelEditButtonLegacy = <Item extends ModelItem>({
  modelKey,
  item,
  translationKey,
  component,
  onClick,
  ...buttonProps
}: ModelEditButtonLegacyProps<Item>) => {
  const { t } = useTranslation();
  const { openSidePanel } = useSidePanel();
  const { canUpdate } = useAuthorization();

  if (!canUpdate(item)) return null;

  const onEditClick: ButtonProps["onClick"] = (e) => {
    const translationBase = translationKey ?? getModelTranslationKey(modelKey);
    const title = t(`${translationBase}:form.edit.label`);

    openSidePanel({ title, component });
    onClick?.(e);
  };

  return (
    <Button onClick={onEditClick} {...buttonProps}>
      {t("global:edit")}
    </Button>
  );
};

export default ModelEditButtonLegacy;
